export const MEMBER_BY_EVENT_REPORT = "Members (by event)";
export const MEMBER_DETAILS_REPORT = "Member (detail)";
export const EVENTS_ALL_REPORT = "Events (all)";
export const LOCATIONS_ALL_REPORT = "Locations (all)";

export const EVENTS_ALL_EVENT = "All";
